import { render, staticRenderFns } from "./SeckillDetails.vue?vue&type=template&id=1a481af6&scoped=true&"
import script from "./SeckillDetails.vue?vue&type=script&lang=js&"
export * from "./SeckillDetails.vue?vue&type=script&lang=js&"
import style0 from "./SeckillDetails.vue?vue&type=style&index=0&id=1a481af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a481af6",
  null
  
)

export default component.exports